module.exports = __webpack_public_path__ + "img/BorrowList.3a0584ce.svg";